// extracted by mini-css-extract-plugin
export default {"Video":"BackgroundVideo_Video__q3grp","Content":"BackgroundVideo_Content__9YEhR","SubContent":"BackgroundVideo_SubContent__kpi+v"};